import { Component, Input } from '@angular/core';

@Component({
  selector: 'spinner',
  standalone: true,
  imports: [],
  templateUrl: './spinner.component.html'
})
export class SpinnerComponent {
  @Input() pageName: string = '';
}
